/* eslint-disable @typescript-eslint/no-explicit-any */
import { IApplicationState } from '../../types/redux';
import { IInteriorDecorationSchema } from '../../repositories/newbuilding-card/entities/decoration/InteriorDecorationSchema';

export function getInteriorDecoration(state: IApplicationState): IInteriorDecorationSchema[] {
  const items = state.newbuilding.interiorDecoration;

  return (items as any).filter(({ images }: any) => images.length);
}
